import Header from "../componentes/Header";
import ConfirmSection from "../componentes/ConfirmSection";

function Confirm() {
    return(
        <>
            <Header/>
            <ConfirmSection/>
        </>
    )
}

export default Confirm;